import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { motion } from 'framer-motion';

export const SectionContainer = styled(motion.section)(({ theme }) => ({
  padding: '1.5rem',
  marginTop: '20rem',

  [theme.breakpoints.up('md')]: {
    padding: '2rem 3rem',
    marginTop: '8rem',
  },

  [theme.breakpoints.up('lg')]: {
    padding: '1.5rem 10rem',
  },
}));

export const CardsWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '0.75rem',
  [theme.breakpoints.up('md')]: {
    gap: '1rem',
  },
}));
